// extracted by mini-css-extract-plugin
module.exports = {"root":"Chat_root__1nueW","messages":"Chat_messages__3UPyB","dateDivider":"Chat_dateDivider__1seU7"};